import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  IconButton,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormControl,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import DrawerUI from "../../common/DrawerUI";
import AppbarUI from "../../common/AppbarUI";
import { Helmet } from "react-helmet";
import BodyWapperUI from "../../common/BodyWapperUI";
import { DatePicker } from "@mui/x-date-pickers";
import { dailyStatsAction } from "../../redux/toolkit/stats/dailyStats";
import { appListAction } from "../../redux/toolkit/apps/list";
import LabelText from "../../common/LabelText";

function Statistic() {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:584px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisher_id, setPublisher_id] = useState();
  const [ativeFilter, setActiveFilter] = useState(false);
  const [pagination, setPagination] = useState({ page: 0, limit: 25 });
  const [email, setEmail] = useState("");
  const [selectedApp, setSelectedApp] = useState({});
  const [pageState, setPageState] = useState({ page: 1, pageSize: 25 });
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const dailyStats = useSelector((state) => state.dailyStats);
  const { status, data, loading: listLoading, total } = dailyStats;
  const { data: appData } = useSelector((state) => state.appLists);

  const dateWiseUser = () => {
    dispatch(
      dailyStatsAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        app_id: selectedApp?._id,
      })
    );
  };

  useEffect(() => {
    dispatch(
      dailyStatsAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        app_id: selectedApp?._id,
      })
    );
  }, [selectedApp]);

  useEffect(() => {
    dispatch(
      dailyStatsAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        email: undefined,
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  useEffect(() => {
    dispatch(appListAction({ is_deleted: false }));
  }, [dispatch]);

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 0.5,
      minWidth: 70,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "Date",
      flex: 1,
      minWidth: 120,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "totalActiveUsers",
      headerName: "Active Users",
      flex: 1,
      minWidth: 120,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "totalClicks",
      headerName: "Survey Clicks",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "completedSurveys",
      headerName: "Survey Completed",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "screenoutSurveys",
      headerName: "Screen Outs",
      flex: 1,
      minWidth: 120,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "offerClicks",
      headerName: "Offer Clicks",
      flex: 1,
      minWidth: 120,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <p>{params?.row?.offerClicks || 0}</p>;
      },
    },
    {
      field: "offerCompleted",
      headerName: "Offer Completed",
      flex: 1,
      minWidth: 140,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <p>{params?.row?.offerCompleted || 0}</p>;
      },
    },
    {
      field: "convertedClicks",
      headerName: "Conversion Rate %",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const conversionRate =
          (params?.row?.completedSurveys / params?.row?.totalClicks) * 100;
        return <p>{Math.floor(conversionRate || 0)}</p>;
      },
    },
    {
      field: "revenue",
      headerName: "Revenue USD",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <p>
            {params?.row?.revenue ? Number(params?.row?.revenue).toFixed(4) : 0}
          </p>
        );
      },
    },
  ];

  const handlePageChange = (params) => {
    setPagination((prevState) => ({
      ...prevState,
      page: params.page,
    }));
  };

  const handlePageSizeChange = (params) => {
    setPagination((prevState) => ({
      ...prevState,
      page: 1,
      pageSize: params.pageSize,
    }));
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    const app = appData.find((item) => item.app_name === selectedValue); // Find the full object
    setSelectedApp(app); // Set the entire object
  };
  return (
    <>
      <Helmet>
        <title> Real Opinion Publisher | Daily Stats </title>
      </Helmet>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        <Typography sx={{ my: 1 }} variant="h6">
          Daily Stats
        </Typography>
        {/* <Stack
          direction="row"
          style={{ display: "flex", justifyContent: "flex-end", gap: 15 }}
        >
          <Stack width={"25%"} justifyContent={"space-between"}>
            <FormControl size="small">
                <LabelText text="In App Product"/>
              <Select
              displayEmpty
                id="select"
                value={selectedApp?.app_name || ""} // Ensure it falls back to an empty string if no app is selected
                onChange={handleChange}
              >
                <MenuItem value="">
                    <em>Select an app</em>
                  </MenuItem>
                {appData?.map((item, i) => (
                  <MenuItem key={i} value={item.app_name}>
                    {item.app_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

          </Stack>
          <Stack direction="row" spacing={2}>
            <Grid xs={6}>
                <LabelText text="Start Date"/>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) => {
                    setDate({ ...date, startDate: newValue });
                  }}
                  renderInput={(params) => <TextField size="small" {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid xs={6}>
            <LabelText text="End Date"/>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" {...params} />}
              />
            </LocalizationProvider>
            </Grid>
            {date.startDate && date.endDate && selectedApp?.app_name && (
              <Button
                variant="contained"
                style={{ backgroundColor: "#0C6A96" }}
                onClick={dateWiseUser}
              >
                find data
              </Button>
            )}
          </Stack>
        </Stack> */}

        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          sx={{
            display: "flex",
            justifyContent: isMobile ? "center" : "flex-end",
            gap: 2,
            alignItems:isMobile ? "center" : "flex-end",
            width: "100%",
          }}
        >
          <Stack width={isMobile ? "100%" : "25%"}>
            <FormControl size="small" fullWidth>
              <LabelText text="In App Product" />
              <Select
                displayEmpty
                id="select"
                value={selectedApp?.app_name || ""}
                onChange={handleChange}
              >
                <MenuItem value="">
                  <em>Select an app</em>
                </MenuItem>
                {appData?.map((item, i) => (
                  <MenuItem key={i} value={item.app_name}>
                    {item.app_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack
            direction={isMobile ? "column" : "row"}
            spacing={2}
            flexWrap="wrap"
            flex={1}
            alignItems={isMobile ? "stretch" : "center"}
          >
            <Grid xs={12} sm={6}>
              <LabelText text="Start Date" />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) =>
                    setDate({ ...date, startDate: newValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      //  placeholder="Start Date"
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "Start Date", // force it inside inputProps
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid xs={12} sm={6}>
              <LabelText text="End Date" />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={date?.endDate}
                  minDate={date?.startDate}
                  maxDate={moment()}
                  onChange={(newValue) =>
                    setDate({ ...date, endDate: newValue })
                  }
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "End Date", // force it inside inputProps
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {date.startDate && date.endDate && selectedApp?.app_name && (
              <Button
                variant="contained"
                sx={{
                  // backgroundColor: "#0C6A96",
                  backgroundColor: "#000",
                  // backgroundImage: "linear-gradient(177.64deg, #FFB100 10.65%, #FE299F 275.27%)",
                  '&:hover': {
                    backgroundColor: "#000",
                  },

                  mt: isMobile ? 2 : 0,
                  width: isMobile ? "100%" : "auto",
                  alignSelf: isMobile ? "stretch" : "end",
                }}
                onClick={dateWiseUser}
              >
                Find Data
              </Button>
            )}
          </Stack>
        </Stack>

        <Paper
          sx={{
            marginTop: 2,
            bgcolor: "#fff",
            "& .super-app-theme--header": {
              background: "rgba(254, 206, 113, 0.16)",
              color: "#000",
              borderBottom: " 1px solid #000",
              fontFamily: "Open Sans",
              fontSize: "13px",
              // textTransform: "uppercase"
            },
          }}
          elevation={0}
        >
          <DataGrid
            sx={{
              border: " 1px solid #000",
              "& .MuiDataGrid-row:hover": {
                background: "rgba(254, 206, 113, 0.16)",
                cursor: "pointer",
              },
            }}
            getRowHeight={({ densityFactor }) => {
              return 70 * densityFactor;
            }}
            autoHeight
            rows={data}
            columns={AppColumns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            pagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            disableColumnSelector
            loading={listLoading ? <LoadingUI /> : false}
            onCellClick={(params) => {
              setPublisher_id(params?.row?._id);
            }}
            components={{
              NoRowsOverlay: () => <NoDataFound />,
              // Toolbar: GridToolbar,
            }}
            rowCount={total}
            paginationModel={setPageState}
            page={pageState.page}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
          />
        </Paper>
      </BodyWapperUI>
    </>
  );
}

export default Statistic;
